import React, { useMemo } from 'react';
import { Values } from '@fiverr-private/dropdown';
import { BriefsTableFilterType, Column, ItemValue } from '../../../../../../types';
import { SingleSelect } from '../SingleSelect';
import { MultiSelect } from '../MultiSelect';

interface FilterProps {
  column: Column<any, unknown>;
}

export const TableFilter = ({ column }: FilterProps) => {
  const { filter } = column.columnDef.meta ?? {};
  const columnFilterValue = column.getFilterValue();
  const sortedUniqueValues = useMemo(() => Array.from(column.getFacetedUniqueValues().keys()).sort(), [column]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const activeFilters = useMemo(() => (column.getFilterValue() as string[])?.length, [column.getFilterValue()]);

  const onFilterSelect = (value: Values) => column.setFilterValue(value?.item);

  switch (filter?.type) {
    case BriefsTableFilterType.Select:
      return (
        <SingleSelect
          label={filter.label || ''}
          onChange={onFilterSelect}
          value={columnFilterValue?.toString()}
          options={sortedUniqueValues}
        />
      );

    case BriefsTableFilterType.MultiSelect:
      return (
        <MultiSelect
          label={filter.label || ''}
          onChange={onFilterSelect}
          value={columnFilterValue as ItemValue[]}
          options={sortedUniqueValues}
          activeFilters={activeFilters}
        />
      );
    default:
      return null;
  }
};
